import {
  border,
  delay,
  font,
  gutter,
  colors
} from '../../../../styles/variables';
import styled, { css } from 'styled-components';

const inputBorderRadius = '8px';
const inputheight = '44px';
const FormPattern = `
  display: block;
  height: ${inputheight};
  line-height: ${inputheight};
  width: 100%;
  border: ${border.input};
  border-radius: ${inputBorderRadius};
  padding: ${gutter.small} ${gutter.default};
  transition: ${delay};
  font-size: ${font.size.default};
  color: ${font.color.default};
  &:focus{
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(4, 113, 156, 0.25);
  }

  ::placeholder{
    color: ${font.color.thead};
    opacity: 1;
    line-height: ${inputheight};
  }

  :-ms-input-placeholder{
    color: ${font.color.thead};
    line-height: ${inputheight};
  }

  ::-ms-input-placeholder{
    color: ${font.color.thead};
    line-height: ${inputheight};
  }
`;

export const Input = styled.input`
  ${FormPattern};
  background-color: ${colors.background.input};

  ${props => props.disabled && css`
    border: ${border.disabled};
    background: #eee;
  `}


  ${props => props.error && css`
    border-color: ${colors.danger.default};
    box-shadow: 0 0 0 0.2rem rgba(231, 76, 60,0.25);
  `}

  ${props => props.withIcon && css`
    padding-left: 42px;
  `}
  
  ${props => props.withPassword && css`
    padding-right: 50px;
  `}
`;

export const Select = styled.select`
  ${FormPattern};
  background-color: ${colors.background.input};
  padding-right: ${gutter.large};
  line-height: calc(${inputheight} - (${gutter.small} * 2));
  ${props => props.error && css`
    border-color: ${colors.danger.default};
  `}
`;

const iconSize = '42px';

const focusLabel = `
  color: ${colors.primary.default};
  font-size: 0.9rem;
  font-weight: ${font.weight.normal};
  top: -10px !important;
  left: 10px;
  z-index: 99;
`;

export const Icon = styled.div`
  height: ${inputheight};
  width: ${iconSize};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;

  position: absolute;
  top: 0;
  left: 0;

  svg, img{
    width: 12px;
    fill: currentColor;
  }
`;

export const InputLabel = styled.label`
  display: block;
  padding: 0;
  color: ${font.color.light};
  font-weight: ${font.weight.normal};
  margin-bottom: ${gutter.small};
  
  position: absolute;
  background: ${colors.background.default};
  left: ${gutter.default};
  top: 12px;
  transition: ${delay};
  z-index: -1;

  ${props => props.required === true && css`
    &:after{
      content: ' *';
      color: ${colors.primary.default};
      display: inline;
      font-size: 80%;
    }
  `};

  ${props => props.withSelect && css`
    ${focusLabel};
  `};

  ${props => props.withLeftIcon && css`
    left: ${iconSize};
  `};
`;

export const Caret = styled.div`
  display: inline-block;

  border-top: 10px solid ${font.color.light};
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;


  position: absolute;
  bottom: 20px;
  right: ${gutter.default};
  z-index: 99;

  ${props => props.error && css`
    bottom: 40px;
  `}
`;

export const InputWrapper = styled.div`
  position: relative;
  
  ${props => props.withLabel && css`

    ${InputLabel}{
      top: 10px;
      /* z-index: 1; */
    }

    input{
      width: 100%;
      &:focus,
      &:invalid,
      &:valid:not(:placeholder-shown){
        outline: none;
        &::placeholder{
          color: #bbb;
        }
        + ${InputLabel}{
          ${focusLabel};
        }
      }
      &:focus{
        ~ .line{
          &:before, &:after{
            width: 50%;
          }
        }
      }
    }
  `}
`;

export const Wrapper = styled.div`
  position: relative;

  select{
    -webkit-appearance: none;
  }

  ${props => props.disabled && css`
    &:after{
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;

      background-color: rgba(0,0,0,0.2);
    }
  `};
`;

export const PasswordButton = styled.button`
  border: none;
  background-color: transparent;
  color: ${font.color.light};
  position: absolute;
  top: 1px;
  right: 1px;
  height: ${inputheight};
  width: 50px;
  padding: .5rem 1rem;
  line-height: 1;
  &:focus{
    outline: none;
  }
  &:hover{
    color: ${colors.primary.default};
  }

  ${props => props.active && css`
    color: ${colors.primary.default};
  `}
`;